@if (this.Status=='EXCEEDED') {
  <div style="background-color: #0480ba; " class="statusdiv">
    EXCEEDED
  </div>
}
@if (this.Status=='ON_TRACK') {
  <div style="background-color: green; " class="statusdiv" >
    ON TRACK
  </div>
}
@if (this.Status=='AT_RISK') {
  <div style="background-color: #cbb202;" class="statusdiv" >
    AT RISK
  </div>
}
@if (this.Status=='OFF_TRACK') {
  <div style="background-color: #d80000;" class="statusdiv" >
    OFF TRACK
  </div>
}
@if (this.Status==null) {
  <div style="background-color: gray ;" class="statusdiv">
    NOT SET
  </div>
}